<template>
  <div id="calenderContainer" class="max-w-screen-md" :class="alignClass">
    <svg v-if="isLoading" class="w-8 h-8 mx-auto animate-spin text-red" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-95" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <!-- v-calendar 3: Prop 'is-expanded' → 'expanded', Popover-Label wird
         via Slot direkt gerendert (statt attributes[].popover.label). -->
    <v-calendar v-else expanded :attributes="attributes">
      <template #day-popover="{ dayTitle, attributes: popoverAttributes }">
        <div class="p-2">
          <div class="mb-2 text-sm font-semibold text-center text-gray-300">
            {{ dayTitle }}
          </div>
          <div v-for="attr in popoverAttributes" :key="attr.key" class="text-xs">
            <a :href="attr.customData.url" target="_blank" class="text-current">
              {{ attr.customData.description }}
            </a>
          </div>
        </div>
      </template>
    </v-calendar>
    <div class="mt-4" v-if="!isLoading">
      <div class="text-left">
        <div class="mb-3 text-lg uppercase font-oswald">Termine filtern:</div>
        <div class="flex flex-wrap lg:flex-nowrap">
          <div class="mr-10">
            <div
              @click="filterEventsByCategory(category.name)"
              v-for="(category, idx) in categories"
              :key="idx"
              :class="{'bg-gray-200': activeCategory === category.name}"
              class="inline-flex items-center px-3.5 py-1.5 mr-2 my-1 transition-colors duration-300 cursor-pointer bg-gray-50">
              <span class="block w-1.5 h-1.5 mr-2 rounded-full bg-red" :style="{ backgroundColor: 'var(--' + category.color + '-600)' }"></span> {{ category.name}}
            </div>
          </div>
          <button @click="resetFilter" class="mt-5 ml-3 text-sm text-gray-500 lg:mt-0 ml lg:ml-auto focus:outline-none" v-if="activeCategory">&times; zurücksetzen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { uniqBy } from 'lodash-es';

const API_URL = '/middelware/findDaysForMonth';

export default {
  name: 'CalendarContainer',
  props: ['align'],
  data: () => ({
    events: [],
    filteredEvents: [],
    activeCategory: '',
    isLoading: true,
    categoryColors: [
      {
        color: 'red',
        uid: 1
      },
      {
        color: 'green',
        uid: 2
      },
      {
        color: 'orange',
        uid: 3
      },
      {
        color: 'blue',
        uid: 4
      },
      {
        color: 'yellow',
        uid: 5
      },
      {
        color: 'teal',
        uid: 6
      },
      {
        color: 'pink',
        uid: 7
      }
    ]
  }),
  async mounted () {
    await this.getEvents();
  },
  computed: {
    alignClass () {
      let className;

      switch (this.align) {
        case 'center':
          className = 'mx-auto';
          break;
        case 'left':
          className = 'mr-auto';
          break;
        case 'right':
          className = 'ml-auto';
          break;

        default:
          className = 'mx-auto';
          break;
      }

      return className;
    },
    categories () {
      return uniqBy(
        this.events.map((event) => ({
          name: event.category,
          color: event.color
        })), 'name');
    },
    attributes () {
      // v-calendar 3: `popover` als boolean (Standard-Anzeige) oder Objekt
      // mit `visibility`. Das Label wird nicht mehr über `popover.label`
      // gesteuert, sondern im Slot #day-popover über `customData` gerendert.
      return [
        ...this.filteredEvents.map(event => ({
          dates: event.dates,
          dot: {
            color: event.color
          },
          popover: {
            visibility: 'focus'
          },
          customData: event
        })),
        {
          key: 'today',
          highlight: {
            color: 'red',
            fillMode: 'light'
          },
          dates: new Date()
        }
      ];
    }
  },
  methods: {
    getCategoryColor (uid) {
      const uidInColors = this.categoryColors.find(color => color.uid === uid);
      return uidInColors ? uidInColors.color : 'purple';
    },
    filterEventsByCategory (categoryName) {
      if (this.activeCategory === categoryName) {
        this.resetFilter();
      } else {
        this.filteredEvents = this.events.filter(event => event.category === categoryName);
        this.activeCategory = categoryName;
      }
    },
    resetFilter () {
      this.filteredEvents = this.events;
      this.activeCategory = '';
    },
    async getEvents () {
      this.isLoading = true;
      try {
        const { data } = await axios.get(API_URL);
        let modifiedData = Object.values(data);
        modifiedData = modifiedData.map((data) => ({
          ...data,
          dates: data.dates.map(date => new Date(date * 1000)),
          color: this.getCategoryColor(data.categoryuid)
        }));
        this.events = modifiedData;
        this.filteredEvents = this.events;
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    }
  }
};
</script>
